// extracted by mini-css-extract-plugin
export default {"root":"ModeToggle_root__VszLt","segment":"ModeToggle_segment__UmjaZ","segmentActive":"ModeToggle_segmentActive__Ud5PO"};